import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomHandlerWithResult } from "@tSchaedlerYesco/Store/CustomHandlerCreator";
import { OrderStatus } from "@tSchaedlerYesco/Types/CustomAPIModels";

interface OrderStatusHandler {
    orderStatus: string;
}

type HandlerType = CustomHandlerWithResult<OrderStatusHandler, OrderStatus>;

export const PopulateOrderStatusBegin: HandlerType = props => {
    props.dispatch({
        type: "Data/PlaceOrder/BeginAddingOrderStatus",
    });
};

export const AddOrderStatus: HandlerType = props => {
    props.dispatch({
        type: "Data/PlaceOrder/AddOrderStatus",
        result: props.parameter,
    });
};

export const chain = [PopulateOrderStatusBegin, AddOrderStatus];

export const addOrderStatus = createHandlerChainRunner(chain, "AddOrderStatus");
export default addOrderStatus;
